import { mapState } from 'vuex'

export default {
  components: {
    HeaderBlock: () => import('~/components/commom/header/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    HealthInsuranceForm: () =>
      import('~/components/layouts/health-insurance-form/index')
  },
  async fetch({ store }) {
    if (store.state.team.members.length === 0) {
      await store.dispatch('team/getTeam')
    }
  },
  data() {
    return {
      activeStep: 0,
      healthData: {},
      isSending: false
    }
  },
  computed: {
    ...mapState(['auth']),
    teamMember() {
      return this.$store.state.team.members[0]
    },
    simulationData() {
      return {
        company_id: 1,
        insured_name: this.healthData.firstName,
        insured_lastname: this.healthData.lastName,
        insured_email: this.healthData.email,
        insured_phone: this.healthData.phone.toString(),
        insured_dob: this.healthData.insuredDob,
        applicants: this.healthData.numberOfApplicants,
        insured_dob_all: this.healthData.insured_dob_all
      }
    }
  },

  methods: {
    isStepActive(index) {
      return index === this.activeStep
    },

    goToNextStep() {
      this.$gtm.pushEvent({
        event:
          this.activeStep === 0
            ? 'health_simulation_start'
            : 'health_simulation_completed'
      })

      this.activeStep++
      window.scrollTo(0, 0)
    },

    submitForm() {
      if (this.isSending) {
        return
      }

      this.isSending = true

      this.sendToServer()
        .then((response) => {
          this.isSending = false

          this.$gtm.pushEvent({
            event: 'health_simulation'
          })

          return this.handleSucessSubmission(response.data)
        })
        .catch((_error) => {
          this.isSending = false
        })
    },

    sendToServer() {
      return this.$axios.post(
        '/healthinsurance/createquote',
        this.simulationData,
        {
          headers: {
            'Content-type': 'application/json; charset=utf-8'
          },
          withCredentials: true
        }
      )
    },

    handleSucessSubmission(response) {
      this.saveSimulationOnStorage(response.uuid)
      this.saveSimulationData(this.simulationData)
      this.$router.push(
        this.localePath({
          name: 'simulacao-seguro-saude-resultados-id',
          params: {
            id: response.uuid
          }
        })
      )
    },
    saveSimulationData(simulationData) {
      return this.$store.commit('localStorage/SAVE_SIMULATION_DATA', {
        simulationData
      })
    },
    saveSimulationOnStorage(id) {
      if (this.auth.isLoggedIn) {
        return
      }

      return this.$store.commit(
        'localStorage/ADD_ANONYMOUS_HEALTH_SIMULATION',
        {
          id
        }
      )
    }
  }
}
